import { formatPhoneNumber } from './phoneUtils';

export const getPhoneNumber = (client) => {
  if (!client.area_code || !client.phone_number) return '-';
  return `${client.area_code}${client.phone_number}`;
};

export const getFullName = (client) => {
  return `${client.first_name} ${client.last_name}`.trim();
};

export const getLastAppointmentDate = (client) => {
  return client.last_appointment ? new Date(client.last_appointment).toLocaleDateString() : '-';
}; 